"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
exports.default = {
    type: "object",
    properties: {
        futureAppointment: (0, common_1.makeAppointmentSchema)({
            disablePast: true,
            isRequired: true,
        }),
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
};
